import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";
import { createPostRedux } from "../redux/create-post-redux/CreatePostRedux";
import { HttpResponseTypeEnum } from "../core/enumerations/ServerRequestStatusEnum";

export function* createPostSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.createPost, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(createPostRedux.actions.createPostSuccess(response.data));
    } else {
      yield put(createPostRedux.actions.createPostFailure(response.data));
    }
  } catch (error) {
    yield put(createPostRedux.actions.createPostFailure(error));
  }
}

export function* getPostDetailsByPostIdSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(api.getPostDetailsByPostId, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(
        createPostRedux.actions.getPostDetailsByPostIdSuccess(response.data)
      );
    } else {
      yield put(
        createPostRedux.actions.getPostDetailsByPostIdFailure(response.data)
      );
    }
  } catch (error) {
    yield put(createPostRedux.actions.getPostDetailsByPostIdFailure(error));
  }
}

export function* getAllPostsByUserIdSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getAllPostsByUserId, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(
        createPostRedux.actions.getAllPostsByUserIdSuccess(response.data)
      );
    } else {
      yield put(
        createPostRedux.actions.getAllPostsByUserIdFailure(response.data)
      );
    }
  } catch (error) {
    yield put(createPostRedux.actions.getAllPostsByUserIdFailure(error));
  }
}

export function* deletePostSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.deletePost, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(createPostRedux.actions.deletePostSuccess(response.data));
    } else {
      yield put(createPostRedux.actions.deletePostFailure(response.data));
    }
  } catch (error) {
    yield put(createPostRedux.actions.deletePostFailure(error));
  }
}

export function* updatePostSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.updatePost, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(createPostRedux.actions.updatePostSuccess(response.data));
    } else {
      yield put(createPostRedux.actions.updatePostFailure(response.data));
    }
  } catch (error) {
    yield put(createPostRedux.actions.updatePostFailure(error));
  }
}
